import { Stepper as MuiStepper, type StepperProps } from "@mui/material";
import Step from "@mui/material/Step";
import clsx from "clsx";
import type { ReactNode } from "react";
import { Circle, IconWrapper, StepLabel, StepperConnector, bbjStepLabelClasses, classes } from "./styles";

interface IStepperIconProps {
  active?: boolean;
  completed?: boolean;
}

const StepperIcon = ({ active = false, completed = false }: IStepperIconProps) => {
  return (
    <IconWrapper
      className={clsx({
        [classes.active]: !!active,
      })}
    >
      <Circle active={active} completed={completed} />
    </IconWrapper>
  );
};

interface IDiagnosisStepperProps extends StepperProps {
  steps: ReactNode[];
  activeStep: number;
}

export const StepperV2 = ({ steps, activeStep, ...props }: IDiagnosisStepperProps) => {
  return (
    <MuiStepper alternativeLabel activeStep={activeStep} connector={<StepperConnector />} {...props}>
      {steps.map((label, index) => (
        <Step
          // biome-ignore lint/suspicious/noArrayIndexKey: No other key available
          key={index}
        >
          <StepLabel StepIconComponent={StepperIcon}>
            ({index + 1}/{steps.length}) <span className={bbjStepLabelClasses.label}>{label}</span>
          </StepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
};
